/* TOMYRIS CUSTOM: нативный scroll и единое переключение фото/пояснения. */
(() => {
  if (customElements.get('tomyris-pdp-story')) return;
  class TomyrisPdpStory extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('[data-story-track]');
      this.slides = Array.from(this.querySelectorAll('[data-story-slide]'));
      if (!this.track || !this.slides.length) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.dots = Array.from(this.querySelectorAll('[data-story-index]'));
      this.caption = this.querySelector('[data-story-mobile-caption]');
      this.mobile = window.matchMedia('(max-width: 767px)');
      this.activeIndex = -1;
      this.addEventListener('click', (event) => {
        const arrow = event.target.closest('[data-story-direction]');
        if (arrow && this.contains(arrow)) this.goTo(this.activeIndex + Number(arrow.dataset.storyDirection));
        const dot = event.target.closest('[data-story-index]');
        if (dot && this.contains(dot)) this.goTo(Number(dot.dataset.storyIndex));
      }, { signal });
      this.track.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      }, { passive: true, signal });
      this.track.addEventListener('keydown', (event) => {
        if (this.dataset.kind === 'details' && !this.mobile.matches) return;
        const index = { ArrowLeft: this.activeIndex - 1, ArrowRight: this.activeIndex + 1, Home: 0, End: this.slides.length - 1 }[event.key];
        if (index === undefined) return;
        event.preventDefault();
        this.goTo(index);
      }, { signal });
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.classList.add('is-ready');
      this.querySelector('[data-story-dots]')?.removeAttribute('hidden');
      this.caption?.removeAttribute('hidden');
      this.update();
    }
    goTo(index) {
      index = Math.max(0, Math.min(this.slides.length - 1, index));
      const delta = this.slides[index].getBoundingClientRect().left - this.slides[0].getBoundingClientRect().left;
      this.track.scrollTo({ left: delta, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    update() {
      const origin = this.track.getBoundingClientRect().left;
      let nearest = 0;
      this.slides.forEach((slide, index) => {
        if (Math.abs(slide.getBoundingClientRect().left - origin) < Math.abs(this.slides[nearest].getBoundingClientRect().left - origin)) nearest = index;
      });
      if (this.dataset.kind === 'details' && !this.mobile.matches) nearest = 0;
      if (nearest === this.activeIndex) return;
      this.activeIndex = nearest;
      const previous = this.querySelector('[data-story-direction="-1"]');
      const next = this.querySelector('[data-story-direction="1"]');
      if (previous) previous.disabled = nearest === 0;
      if (next) next.disabled = nearest === this.slides.length - 1;
      this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === nearest)));
      const source = this.slides[nearest].querySelector('[data-story-caption]');
      if (this.caption && source) this.caption.replaceChildren(...Array.from(source.childNodes, (node) => node.cloneNode(true)));
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  }
  customElements.define('tomyris-pdp-story', TomyrisPdpStory);
})();
